import { matchRoutes } from 'react-router-dom';

import { PREVIEW_ROUTES, ROUTES } from '../constants';

/**
 * Checks if the current route is a preview route
 * @param {string} pathname - The path to check (defaults to window.location.pathname)
 * @returns {boolean} True if current route is a preview route
 */
const isPreviewRoute = (pathname = window.location.pathname) => {
  const previewPaths = Object.values(PREVIEW_ROUTES)
    .flat()
    .map((previewPath) => ({ path: `${ROUTES.DETAILS}${previewPath}` }));

  const matchedRoutes = matchRoutes(previewPaths, pathname);
  return Boolean(matchedRoutes?.length);
};

export default isPreviewRoute;
